<template>
  <div class="footer_box">
    <div class="footer">
      
      <div class="bottom">
        <div class="left">
          <ul>
            <li style="cursor:pointer;" @click="$router.push('/home')" class="title">首页</li>
            <li style="cursor:pointer;" @click="$router.push('/about')" >关于我们</li>     
            <li style="cursor:pointer;" @click="$router.push('/serve')">服务内容</li>
            <li style="cursor:pointer;" @click="$router.push('/project')">项目经验</li>
            <li style="cursor:pointer;" @click="$router.push('/news?id=8,10,11&list=公司新闻,行业新闻,最新公告')">新闻资讯</li>
            <li style="cursor:pointer;" @click="$router.push('/contact')">联系我们</li>
          </ul>
          <ul>
            <li class="title">友情链接</li>      
            <li><a style="color:#fff;" href="http://jlthcy.com/" target="_blank"  >创优检测</a></li>
            <li> <a style="color:#fff;" href="https://www.nmpa.gov.cn/" target="_blank"  >NMPA</a> </li>     
            <li><a style="color:#fff;" href="http://www.cde.org.cn/" target="_blank"  >CDE</a> </li>
            <li> <a style="color:#fff;" href="http://www.ema.europa.eu" target="_blank"  >EMA</a></li>
            <li><a style="color:#fff;" href="https://www.fda.gov/" target="_blank"  >FDA</a></li>
            <!-- <li> <a style="color:#fff;" href="https://www.cmde.org.cn/CL0001/" target="_blank"  >CMDE</a></li> -->
          </ul>
          <ul>
            <li class="title">联系我们</li>   
            <li>地址/ADDRESS：北京朝阳区左家庄中街6号豪成大厦21层</li>      
            <li>电话/TELEPFONE：010-84606112 </li>
            <!-- 13911905318(商务洽谈) -->
            <li>传真/FAX：010-84605026</li>
            <li>邮箱/EMAIL：bd@sinocro.com.cn</li>
          </ul>
        </div>

        <div class="telleft">
        </div>
        <div class="right">
          <img src="../../assets/images/xdt-code.png" alt="">
          <p>关注官方公众号</p>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      A sinocro company . All rights reserved . 京ICP备15022937号-1     sinocro company . All rights reserved . 京ICP备15022937号-1     Sinocro ® © 2006 兴德通公司 版权所有 
    </div>
    <div class="footer-bottom-mob">
      Sinocro ® © 2006 兴德通公司 版权所有 
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      androidPathCode: "",
      iosPathCode: "",
    };
  },
  created() {
  },
  methods: {
    
  },
};
</script>

<style scoped>
.footer-bottom-mob{
  display: none;
}
.footer-bottom{
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background: #191919;
  color: #fff;
  font-size: 14px;
}
.footer_box {
  /* background-image: url(../../assets/images/footer-bj.png); */
  background-color: #333333;
  background-repeat:no-repeat ;
  background-size: 100% 334px;
  width: 100%;
}
.footer {
  max-width: 1200px;
  padding: 28px 15px 12px;
  margin: 0 auto;
  box-sizing: border-box;
  color: #ffff;
  overflow: hidden;
  text-align: left;
}
.footer .bottom {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.footer .bottom .left {
  display: flex;
  color: #fff;
  font-family: Source Han Sans CN;
}
.footer .bottom .left .title{
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 28px;
}
.footer .bottom .left li{
  margin-bottom: 20px;
  font-size: 18px;
}
.footer .bottom .left ul:nth-child(1){
  margin-right: 58px;
}
.footer .bottom .left ul:nth-child(2){
  margin-right: 38px;
}
.footer .bottom .right {
  text-align: center;
  color: #fff;
  font-size: 18px;
  width: 180px;
  letter-spacing: 3px;
}
.footer .bottom .right img{
  margin-bottom: 18px;
}
.footer .bottom .right p{
  letter-spacing: 10px;
  word-break:keep-all;           /* 不换行 */
white-space:nowrap;          /* 不换行 */      /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
}
@media only screen and (max-width: 768px) {
  .footer .bottom .left{
    display: block;
  }
  .footer .bottom .left li{
    margin-bottom: 12px;
    font-size: 12px;
  }
  .footer .bottom .left .title{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .footer .bottom .right{
    margin: 20px auto;
  }
  .footer .bottom .right p{
    font-size: 16px;
    letter-spacing: 3px;
  }
  .footer-bottom{
    display: none;
  }
  .footer-bottom-mob{
    font-size: 12px;
    padding: 15px 0;
    display: block;
    color: #fff;
    background: #000;
  }
  


}


</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue